import { initialSysErrorCodeState, actions } from "./action";

export const sysErrorCodeReducer = (state = initialSysErrorCodeState, action) => {
    switch (action.type) {
        case actions.SYSERRORCODE_GET_ALL_SUCCESS:
            return {
                ...state,
                sysErrorCodeList: action.payload ? action.payload : {}
            };
        case actions.SYSERRORCODE_UPDATE_SUCCESS:
            return {
                ...state,
                sysErrorCode: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.SYSERRORCODE_CREATE_SUCCESS:
            return {
                ...state,
                sysErrorCode: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.SYSERRORCODE_DELETE_SUCCESS:
            return {
                ...state,
                sysErrorCode: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.SYSERRORCODE_RESET_SUCCESS:
            return {
                ...state,
                sysErrorCode: {},
                filters: {}
            };
        case actions.SYSERRORCODE_SET_FILTERS_REQUEST:
            return {
                ...state,
                filters: action.payload
            };
        default:
            return state;
    }
};
